import { render, staticRenderFns } from "./create-event.vue?vue&type=template&id=c0f82c8a&"
import script from "./create-event.vue?vue&type=script&lang=js&"
export * from "./create-event.vue?vue&type=script&lang=js&"
import style0 from "./create-event.vue?vue&type=style&index=0&id=c0f82c8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports